/* eslint-disable react/jsx-max-depth */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import invariant from 'tiny-invariant';
import Page from '../../components/page/Page';
import Icon from '../../components/icon/Icon';
import text, { formatCurrency } from '../../text';
import { useGetJobQuery } from '../../redux/rtk';
import useUrlParam from '../hooks/useUrlParam';
import { useDispatch, useSelector } from 'react-redux';
import { getJob, getMembershipPrices, getUserProfile, setMembershipPriceId } from '../../redux/actions';
import { MEMBERSHIP } from '../../constants/membership';
import useUser from '../hooks/useUser';
import { isJobPayable } from '../../utilities/job';
import { isMembershipPriceId } from '../../utilities/membership';
import { isRouteIncluded } from '../../utilities/routes';
import ProductInvoice from '../components/Payment/ProductInvoice';
import MembershipInvoice from '../components/Payment/MembershipInvoice';
import { InvoiceTotal } from '../../pages/billing/Invoice/InvoiceTotal';
import ForQuotation from '../components/Payment/ForQuotation';
import OrderWizard from '../../pages/billing/OrderWizard/OrderWizard';
import PaymentProvider from '../../pages/billing/PaymentContext';
import { useRedirect } from '../../hooks/useRedirect';
import { isUserGovernment } from '../../utilities/user';
import { GST } from '../../constants/price';
import CtaButton from '../../components/RightMenu/CtaButton';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PaymentContext as OtherPaymentContext } from '../../pages/billing/PaymentContext';
var PaymentContext = /*#__PURE__*/ createContext(null);
export var usePaymentContext = function() {
    var ctx = useContext(PaymentContext);
    invariant(ctx, 'PaymentContext must be used within a PaymentContext.Provider');
    return ctx;
};
var WIZARD_KEYS = {
    order: 'order',
    membership: 'membership'
};
var PaymentPage = function(param) {
    var jobId = param.jobId, job = param.job, isJobLoading = param.isJobLoading;
    var location = useLocation();
    var redirect = useRedirect();
    var currentUser = useUser();
    var dispatch = useDispatch();
    var _useSelector = useSelector(function(state) {
        return {
            membershipPriceId: state.order.membershipPriceId,
            membershipPrices: state.profileReducer.membershipPrices
        };
    }), membershipPriceId = _useSelector.membershipPriceId, membershipPrices = _useSelector.membershipPrices;
    var _useState = _sliced_to_array(useState(text('estimate')), 2), cardHeading = _useState[0], setCardHeading = _useState[1];
    var otherPaymentContext = useContext(OtherPaymentContext);
    var activeWizardStep = otherPaymentContext.states.activeWizardStep, wizzardFunctions = otherPaymentContext.refs.wizzardFunctions;
    var cartItemsAutomatic = useMemo(function() {
        var _job_quote;
        return job === null || job === void 0 ? void 0 : (_job_quote = job.quote) === null || _job_quote === void 0 ? void 0 : _job_quote.charges.filter(function(charge) {
            var _charge_details;
            return ((_charge_details = charge.details) === null || _charge_details === void 0 ? void 0 : _charge_details.delivery_method) === 'automatic';
        });
    }, [
        job === null || job === void 0 ? void 0 : job.quote
    ]);
    var selectedMembership = useMemo(function() {
        var _membershipPrices_value;
        return (_membershipPrices_value = membershipPrices.value) === null || _membershipPrices_value === void 0 ? void 0 : _membershipPrices_value.find(function(membership) {
            return membership.id === membershipPriceId;
        });
    }, [
        membershipPriceId,
        membershipPrices
    ]);
    var numBillableItems = useMemo(function() {
        return [
            cartItemsAutomatic === null || cartItemsAutomatic === void 0 ? void 0 : cartItemsAutomatic.length,
            selectedMembership
        ].filter(Boolean).length;
    }, [
        cartItemsAutomatic === null || cartItemsAutomatic === void 0 ? void 0 : cartItemsAutomatic.length,
        selectedMembership
    ]);
    var wizardStepsHeading = useMemo(function() {
        var _obj;
        return _obj = {}, _define_property(_obj, WIZARD_KEYS.order, [
            {
                text: text('estimate'),
                filter: function() {
                    return !process.env.DISABLE_STRIPE && !currentUser.isGovernment && !currentUser.isStaff && (!currentUser.hasValidMembership || currentUser.isUserUnderTrial);
                }
            },
            {
                text: text('estimate')
            },
            {
                text: text('quote'),
                filter: function() {
                    return !currentUser.isStaff && isJobPayable(job) || isMembershipPriceId(membershipPriceId);
                }
            },
            {
                text: text('invoice')
            }
        ]), _define_property(_obj, WIZARD_KEYS.membership, [
            {
                text: text('estimate')
            },
            {
                text: text('quote')
            }
        ]), _obj;
    }, [
        currentUser.hasValidMembership,
        currentUser.isGovernment,
        currentUser.isStaff,
        currentUser.isUserUnderTrial,
        job,
        membershipPriceId
    ]);
    var wizardKeys = useMemo(function() {
        return [
            {
                key: WIZARD_KEYS.order,
                isActive: isRouteIncluded([
                    '/mp/:jobId/payment'
                ])(location.pathname)
            },
            {
                key: WIZARD_KEYS.membership,
                isActive: isRouteIncluded([
                    '/user/membership/management'
                ])(location.pathname)
            }
        ];
    }, [
        location.pathname
    ]);
    var getActiveRouteKey = useMemo(function() {
        if (!activeWizardStep) {
            return text('estimate');
        }
        return wizardKeys.find(function(wk) {
            return !!wk.isActive;
        });
    }, [
        activeWizardStep,
        wizardKeys
    ]);
    useEffect(function() {
        dispatch(setMembershipPriceId(MEMBERSHIP.NO_MEMBERSHIP));
        dispatch(getMembershipPrices());
        dispatch(getUserProfile());
        dispatch(getJob(jobId));
    }, [
        dispatch,
        jobId
    ]);
    var isFreeUser = useMemo(function() {
        if (isUserGovernment(currentUser.profile)) return false;
        return !currentUser.hasValidMembership || currentUser.isUserUnderTrial;
    }, [
        currentUser
    ]);
    var isInProjectStep = activeWizardStep && activeWizardStep.step === 2;
    var memberBuyNowDiscount = useMemo(function() {
        if (!(job === null || job === void 0 ? void 0 : job.quote)) {
            return null;
        }
        var _job_quote = job.quote, _job_quote_gst = _job_quote.gst, gst = _job_quote_gst === void 0 ? GST : _job_quote_gst, price = _job_quote.price, currency = _job_quote.currency;
        return formatCurrency(price.member_automatic_discount_total * (1 + gst / 100), currency.name, currency.scale_factor, {}, true);
    }, [
        job === null || job === void 0 ? void 0 : job.quote
    ]);
    var isMembershipCtaVisible = isFreeUser && isInProjectStep && !isMembershipPriceId(membershipPriceId) && // if no membership selected from previous step (noMembership)
    memberBuyNowDiscount;
    return /*#__PURE__*/ React.createElement(PaymentContext.Provider, {
        value: {
            job: job,
            isJobLoading: isJobLoading,
            cartItemsAutomatic: cartItemsAutomatic,
            numBillableItems: numBillableItems,
            cardHeading: cardHeading
        }
    }, /*#__PURE__*/ React.createElement(Page, {
        className: "Payment"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "main-wrapper"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "invoice-wrapper"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "invoice-section"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ React.createElement(Link, {
        onClick: function() {
            return redirect.goBack();
        },
        className: "d-flex align-items-center",
        to: "#"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "caret-left"
    }), text('backTo2DMap'), ":")), (cartItemsAutomatic === null || cartItemsAutomatic === void 0 ? void 0 : cartItemsAutomatic.length) ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", {
        className: "invoice-title text-uppercase font-16 mb-3"
    }, text('buyNow'), ":"), /*#__PURE__*/ React.createElement(ProductInvoice, null)) : null, isFreeUser && !currentUser.isStaff ? /*#__PURE__*/ React.createElement(MembershipInvoice, {
        numOrder: numBillableItems,
        isFromOrderWizard: true
    }) : null, (cartItemsAutomatic === null || cartItemsAutomatic === void 0 ? void 0 : cartItemsAutomatic.length) || !currentUser.hasValidMembership && !currentUser.isStaff && isMembershipPriceId(membershipPriceId) ? /*#__PURE__*/ React.createElement(InvoiceTotal, {
        quote: job === null || job === void 0 ? void 0 : job.quote,
        currentUser: currentUser,
        membershipPriceId: membershipPriceId,
        selectedMembership: selectedMembership
    }) : /*#__PURE__*/ React.createElement("div", {
        className: "mt-3"
    }), isMembershipCtaVisible ? /*#__PURE__*/ React.createElement(CtaButton, {
        className: "mb-2",
        show: true,
        header: text('membership'),
        description: text('ctaMembershipSubtitle', {
            amount: "-".concat(memberBuyNowDiscount)
        }),
        titleClassNames: "pl-2 font-14",
        subTitleClassNames: "pl-2 pink font-14 font-italic mt-2",
        isTertiary: true,
        // @ts-expect-error prop
        tooltip: /*#__PURE__*/ React.createElement(OverlayTrigger, {
            trigger: [
                'hover',
                'focus'
            ],
            placement: "top",
            overlay: /*#__PURE__*/ React.createElement(Tooltip, {
                id: "other-charge-tooltip"
            }, text('ctaMembershipTooltip'))
        }, /*#__PURE__*/ React.createElement(Icon, {
            icon: "question",
            className: "other-charge-icon",
            // @ts-expect-error prop
            style: {
                pointerEvents: 'auto'
            }
        })),
        handleClick: function() {
            if (wizzardFunctions.current) {
                dispatch(setMembershipPriceId(MEMBERSHIP.YEARLY.PRICE_ID));
                wizzardFunctions.current.previousStep();
            }
        }
    }) : null, /*#__PURE__*/ React.createElement(ForQuotation, {
        numOrder: numBillableItems
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "order-wizard"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "section"
    }, /*#__PURE__*/ React.createElement(OrderWizard, null))))));
};
var PaymentPageProvider = function() {
    var redirect = useRedirect();
    var jobId = useUrlParam('jobId', {
        int: true,
        onParseError: function() {
            return redirect.goBack();
        }
    });
    var _useGetJobQuery = useGetJobQuery(jobId), job = _useGetJobQuery.data, isJobLoading = _useGetJobQuery.isLoading;
    return /*#__PURE__*/ React.createElement(PaymentProvider, {
        job: job
    }, /*#__PURE__*/ React.createElement(PaymentPage, {
        jobId: jobId,
        job: job,
        isJobLoading: isJobLoading
    }));
};
export default PaymentPageProvider;
